export enum EventTabsEnum {
  RESOURCES = 'resources',
  MY_ROSTERS = 'myRosters',
  ALL_ROSTERS = 'allRosters',
}

export enum ResourcesTabEnum {
  LINEMEN = 'linemen',
  VEHICLES = 'vehicles',
  SUPPORT = 'support',
}
